module.exports = __webpack_public_path__ + "img/home_business_2.7ae5b1ee.png";